import React from 'react'
import PropTypes from 'prop-types'
import {Box, useMultiStyleConfig} from '@chakra-ui/react'
import {Swiper, SwiperSlide} from 'swiper/react'
import {Pagination} from 'swiper/modules'
import Benefit from './benefit'
import {remCalc} from '../../theme/_utils'

const BenefitIconsSwiper = ({benefitGroup}) => {
    const swiperStyles = useMultiStyleConfig('Swiper')

    return (
        <Box
            data-testid="swiper-container"
            width="100%"
            height="100%"
            maxW={{
                base: '100dvw',
                md: remCalc(386),
                lg: remCalc(386),
                xl: remCalc(570),
            }}
            maxH={{
                base: remCalc(260),
                md: remCalc(386),
                lg: remCalc(386),
                xl: remCalc(570),
            }}
            __css={{
                ...swiperStyles,
                '.benefit-bar-pagination': {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: remCalc(8),
                    marginTop: remCalc(16),
                },
                '.benefit-bar-pagination .swiper-pagination-bullet': {
                    width: remCalc(6),
                    height: remCalc(6),
                    borderRadius: 'full',
                    opacity: 1,
                    backgroundColor: 'background.base.deep',
                    margin: '0 !important',
                },
                '.benefit-bar-pagination .swiper-pagination-bullet.swiper-pagination-bullet-active':
                    {
                        width: remCalc(12),
                        backgroundColor: 'background.strong.default',
                    },
            }}
        >
            <Swiper
                data-testid="swiper"
                pagination={{
                    clickable: true,
                    el: '.benefit-bar-pagination',
                }}
                modules={[Pagination]}
                className="befit-icons-swiper"
            >
                {benefitGroup.map(({description, title, icon}, index) => (
                    <SwiperSlide key={index}>
                        <Benefit
                            title={title}
                            description={description}
                            url={icon?.url}
                            alt={title}
                        />
                    </SwiperSlide>
                ))}
                <Box className="benefit-bar-pagination" />
            </Swiper>
        </Box>
    )
}

BenefitIconsSwiper.propTypes = {
    benefitGroup: PropTypes.arrayOf(
        PropTypes.shape({
            description: PropTypes.string,
            title: PropTypes.string,
            icon: PropTypes.shape({url: PropTypes.string}),
        }),
    ),
}

export default BenefitIconsSwiper
